<div class="login-wrapper">
  <div class="login-container">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <h1>Confira as informações do laudo</h1>
      <div class="form-group">
        <app-input
          type="text"
          label="Digite o CPF ou CNPJ da empresa:"
          placeholder="000.000.000-00 ou 00.000.000/0001-00"
          name="TX_CNPJ_EPSA"
          formControlName="TX_CNPJ_EPSA"
          mask="000.000.000-00||00.000.000/0000-00"></app-input>
        <app-input
          type="number"
          label="Número do Laudo"
          placeholder="Digite o número do laudo"
          name="PK_LAUD_SRVC"
          formControlName="PK_LAUD_SRVC"></app-input>
      </div>
      <button type="submit" class="button" [disabled]="!form.valid">
        Verificar
      </button>
    </form>
  </div>
  <div class="image-container">
    <img src="assets/LogoLavaLog.svg" />
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
